import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const ErrorOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.91 12c0-4.36-3.55-7.91-7.91-7.91S4.09 7.64 4.09 12s3.55 7.91 7.91 7.91 7.91-3.55 7.91-7.91ZM2.29 12c0-5.36 4.35-9.71 9.71-9.71 5.36 0 9.71 4.35 9.71 9.71 0 5.36-4.35 9.71-9.71 9.71-5.36 0-9.71-4.35-9.71-9.71Zm9.18.56c.03.21.1.37.22.48v-.01c.12.11.26.17.43.17.17 0 .31-.06.43-.17.12-.11.19-.27.21-.48l.64-3.72c.01-.05.01-.11.01-.19 0-.36-.12-.64-.36-.85-.24-.21-.55-.31-.92-.31s-.67.1-.92.31-.37.49-.37.85c0 .08.01.19.01.19l.62 3.73Zm-.52 2.35c0 .33.11.61.33.83.22.23.5.34.83.34a1.147 1.147 0 0 0 1.15-1.17c0-.33-.11-.61-.33-.83a1.08 1.08 0 0 0-.82-.34c-.33 0-.61.11-.83.34-.22.23-.33.5-.33.83Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default ErrorOutlined
